import './App.css';
// import MidiFileInfo from './MidiFileInfo';
import FileDropper from './FileDropper';
import MidiToChordOrgan from './MidiToChordOrgan';
import React, {Component} from 'react';
import injectTapEventPlugin from 'react-tap-event-plugin';
import once from 'lodash/once';
import AppBar from 'material-ui/AppBar';
import myTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Toggle from 'material-ui/Toggle';
import Slider from 'material-ui/Slider';
import FlatButton from 'material-ui/FlatButton';
import Divider from 'material-ui/Divider';
import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';

const tapInitOnce = once(() => injectTapEventPlugin());

class App extends Component {
  constructor() {
    super();

    this.midiProcessor = new MidiToChordOrgan();

    this.state = {
      midiInfo: {},
      extraWaves: false,
      glide: false,
      glideTime: 50,
      noteRange: 39,
      customNoteRange: false,
      stacked: false,
      quantiseRootKnob: true,
      quantiseRootCV: true,
      chordText: this.midiProcessor.getDefaultChordString(),
        firmwareUrl: "https://github.com/TomWhitwell/Chord-Organ/releases"
    };

    this.noteRangeChanged = this.noteRangeChanged.bind(this);
    this.glideTimeChanged = this.glideTimeChanged.bind(this);
    this.toggleGlide = this.toggleGlide.bind(this);
    this.toggleWaves = this.toggleWaves.bind(this);
    this.toggleStacked = this.toggleStacked.bind(this);
    this.toggleCustomNoteRange = this.toggleCustomNoteRange.bind(this);
    this.exportSettings = this.exportSettings.bind(this);
    this.downloadFirmware = this.downloadFirmware.bind(this);
    this.chordTextChanged = this.chordTextChanged.bind(this);
    this.toggleRootCVQuantise = this.toggleRootCVQuantise.bind(this);
    this.toggleRootKnobQuantise = this.toggleRootKnobQuantise.bind(this);
  }

  downloadFirmware() {
    console.log("Download Firmware");
    window.open(this.state.firmwareUrl);
  }

  exportSettings() {
    console.log("Export Settings");
    this.midiProcessor.exportChordOrganFile(this.state);
  }

  toggleGlide(event, value) {
    this.setState({glide: value});
  }

  toggleCustomNoteRange(event, value) {
    this.setState({customNoteRange: value});
  }

  toggleWaves(event, value) {
    this.setState({extraWaves: value});
  }

  toggleStacked(event, value) {
    this.setState({stacked: value});
  }

  toggleRootKnobQuantise(event, value) {
    this.setState({quantiseRootKnob:value})
  }

  toggleRootCVQuantise(event, value) {
    this.setState({quantiseRootCV:value})
  }

  noteRangeChanged(event, value) {
    this.setState({noteRange: value});
  }

  glideTimeChanged(event, value) {
    this.setState({glideTime: value});
  }

  chordTextChanged(event) {
    this.setState({chordText: event.target.value});
  }

  processMidi(data) {
    try {
      let midiInfo = this.midiProcessor.processMidi(data);
      this.setState({midiInfo: midiInfo, chordText: this.midiProcessor.chordListString});
      //this.midiProcessor.exportChordOrganFile();
    } catch (err) {
      this.setState({errorMessage: err.message});
    }
  }

  componentDidMount() {
      // self = this;

      fetch('https://api.github.com/repos/TomWhitwell/Chord-Organ/releases/latest')
          .then(r => r.json() )
          .then (data => {
              console.log('Got release data',data.assets[0].browser_download_url);
              this.setState({firmwareUrl:data.assets[0].browser_download_url})
          })
          .catch(e => console.log('Fetch failed'))
  }

  render() {
    const buttonStyle = {
      backgroundColor: 'transparent',
      color: 'white',
      marginTop: '4px'
    };
    tapInitOnce();
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(myTheme)}>
        <div>
          <AppBar
            title="Chord Organ"
            iconElementLeft={<img src="ThonkLogo.png" alt="logo"/>}
            iconElementRight={<div><FlatButton label="Download Firmware" style={buttonStyle} onTouchTap={this.downloadFirmware}/><FlatButton label="Download Config" style={buttonStyle} onTouchTap={this.exportSettings}/></div>}
            showMenuIconButton={false}
          />
          <p className="info"><span>All configuration options below are set in the configuration file which you will need to download and copy to the SD card</span></p>
          <p className="info"><span>Full release notes are available <a href="https://github.com/TomWhitwell/Chord-Organ/releases">here</a></span></p>

          <div className="configColumn">

            <p className="hint" style={{marginTop: "10px", marginBottom: "5px"}}><span>Chord List</span></p>

            {/*<MidiFileInfo info={this.state.midiInfo}/>*/}
            <textarea rows="16" onChange={this.chordTextChanged}
                      style={{width: "100%", resize: "none", overflow: "hidden", marginTop: "8px", paddingRight: "0px"}}
                      value={this.state.chordText}/>
            <FileDropper onload={(data) => this.processMidi(data)}/>
            <p className="hint"><span>Enable 2 extra pages of waveforms</span></p>
            <Toggle
              name="extraWaves"
              label="Use Extra Waves"
              onToggle={this.toggleWaves}
              defaultToggled={this.state.extraWaves}
            />
            <Divider style={{marginTop: "16px"}}/>
            <p className="hint"><span>Double first 4 voices. NOTE : Only first 4 entries in chord will be used.</span>
            </p>
            <Toggle
              name="stacked"
              label="Double first 4 voices"
              onToggle={this.toggleStacked}
              defaultToggled={this.state.stacked}
            />
            <Divider style={{marginTop: "16px"}}/>
            <p className="hint" style={{marginTop: "16px"}}><span>Glide between notes</span></p>
            <Toggle
              style={{"marginTop": "10px"}}
              name="glide"
              label="Glide"
              onToggle={this.toggleGlide}
              defaultToggled={this.state.glide}
            />
            <p><span>Glide Time {this.state.glideTime} ms</span></p>
            <Slider
              min={5}
              max={300}
              step={1}
              defaultValue={50}
              onChange={this.glideTimeChanged}
              value={this.state.glideTime}
              disabled={!this.state.glide}
              sliderStyle={{marginBottom: "16px"}}
            />
            <p className="hint" style={{marginTop: "16px"}}><span>Range of notes for Root CV Input.</span></p>
            <Toggle
              style={{"marginTop": "10px"}}
              name="customNoteRange"
              label="Custom Note Range"
              onToggle={this.toggleCustomNoteRange}
              defaultToggled={this.state.customNoteRange}
            />
            <p><span>Root CV Range {this.state.noteRange}</span></p>
            <Slider
              min={12}
              max={72}
              step={1}
              defaultValue={38}
              onChange={this.noteRangeChanged}
              value={this.state.noteRange}
              disabled={!this.state.customNoteRange}
              sliderStyle={{marginBottom:"16px"}}
            />
            <p className="hint" style={{marginTop: "16px"}}><span>Root CV and Knob quantise.</span></p>
            <Toggle
              style={{"marginTop": "10px"}}
              name="quantiseRootCV"
              label="Quantise Root CV"
              onToggle={this.toggleRootCVQuantise}
              defaultToggled={this.state.quantiseRootCV}
            />
            <Toggle
              style={{"marginTop": "10px", "marginBottom":"10px"}}

              name="quantiseRootKnob"
              label="Quantise Root Knob"
              onToggle={this.toggleRootKnobQuantise}
              defaultToggled={this.state.quantiseRootKnob}
            />
            <RaisedButton
              href="https://github.com/TomWhitwell/Chord-Organ/issues"
              target="_blank"
              label="NEED HELP?"
              secondary={true}
              fullWidth={true}
              icon={<FontIcon className="muidocs-icon-custom-github" />}
            />
          </div>

        </div>
      </MuiThemeProvider>
    );
  };
}

/**
 * value={this.state.secondSlider}
 * onChange={this.handleSecondSlider}
 */
export default App;


// WEBPACK FOOTER //
// ./src/App.js